import React from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import 'jspdf-autotable';

class Invoice extends React.Component {

    totals = { mount: 0, mountAfterIVA: 0, mountBeforeIVA: 0, totalDiff: 0 };

    getAvailableKeys() {
        const { cart } = this.props;
        const cartKeys = Object.keys( cart );
        var result = [];

        cartKeys.map( key => Object.keys( cart[key].items ).length > 0 ? result.push(key) : null );

        return result;
    }

    getDetail(key, index, last) {
        const { cart } = this.props;
        var table = null;
        var rowSIva = (key === 'renta') ? 'Impuesto antes' : 'Precio antes';
        var rowCIva = (key === 'renta') ? 'Impuesto ahora' : 'Precio ahora';

        //totals
        var mount = 0;
        var mountBeforeIVA = 0;
        var mountAfterIVA = 0;
        var totalDiff = 0;

        var itemsKey = Object.keys( cart[key].items );
        var thead = <thead>
                        <tr><th className="category-name" colSpan="6">{cart[key].category}</th></tr>
                        <tr>
                            <th scope="col" className="item"><b>Producto o servicio</b></th>
                            <th scope="col">Quitar</th>
                            <th scope="col">Monto</th>
                            <th scope="col">{rowSIva}</th>
                            <th scope="col">{rowCIva}</th>
                            <th scope="col" className="difference">Diferencia</th>
                        </tr>
                    </thead>

        var bodyElements = [];

        itemsKey.map(
            (itemKey, idx) => {
                bodyElements.push(
                    <tr key={`body-el-${cart[key].items[itemKey].name}-${idx}`}>
                        <th scope="row" className="item">{cart[key].items[itemKey].name}</th>
                        <td className="delete-item"><button type="button" className="delete-button" onClick={(event) => this.props.deleteFromCart(key, itemKey)}>x</button></td>
                        <td>{cart[key].items[itemKey].oldValue}</td>
                        <td>{cart[key].items[itemKey].prevValue !== undefined ? cart[key].items[itemKey].prevValue : cart[key].items[itemKey].oldValue}</td>
                        <td>{cart[key].items[itemKey].newValue}</td>
                        <td className="difference">{cart[key].items[itemKey].diff}</td>
                    </tr>
                );
                mount = mount + parseInt( cart[key].items[itemKey].oldValue, 10);
                mountBeforeIVA = mountBeforeIVA + parseInt( (cart[key].items[itemKey].prevValue !== undefined ? cart[key].items[itemKey].prevValue : cart[key].items[itemKey].oldValue), 10 );
                mountAfterIVA = mountAfterIVA + parseInt( cart[key].items[itemKey].newValue, 10 );
                totalDiff = totalDiff + parseInt( cart[key].items[itemKey].diff, 10 );
            }
        );

        bodyElements.push(
            <tr key={`${cart[key].category}-totals-${index}`} className="totals">
                <th className="total-category">Total</th>
                <td></td>
                <th>{mount}</th>
                <th>{mountBeforeIVA}</th>
                <th>{mountAfterIVA}</th>
                <th className="difference">{totalDiff}</th>
            </tr>
        );

        this.totals.mount = this.totals.mount + mount;
        this.totals.mountAfterIVA = this.totals.mountAfterIVA + mountAfterIVA;
        this.totals.mountBeforeIVA = this.totals.mountBeforeIVA + mountBeforeIVA;
        this.totals.totalDiff = this.totals.totalDiff + totalDiff;

        if( last ) { bodyElements.push( this.getTotals() ); }

        var tbody = <tbody>{bodyElements}</tbody>
        
        var table = <table key={`${cart[key].category}-${index}`} className="table">{thead}{tbody}</table>

        return table;
    }

    getTotals() {
        return  <tr key={`invoice-big-totals`} className="BIGTOTAL">
                    <th className="total-final">Total general</th>
                    <th></th>
                    <th>{/* this.totals.mount */}</th>
                    <th>{this.totals.mountBeforeIVA}</th>
                    <th>{this.totals.mountAfterIVA}</th>
                    <th className="difference">{this.totals.totalDiff}</th>
                </tr>;
    }

    initTotals() {
        this.totals = { mount: 0, mountAfterIVA: 0, mountBeforeIVA: 0, totalDiff: 0 };
    }

    generatePdf() {
        const { cart } = this.props;
        const availableKeys = this.getAvailableKeys(), catLenght = availableKeys.length;
        var line = 20, breakLine = 10, margin = 14;
        var image = document.createElement("IMG");
        image.src = './img/logofactura.png';
        //image.src = 'https://www.nacion.com/pb/resources/assets/la_nacion/img/gn_colors.png';

        window.html2canvas = html2canvas;
        var doc = new jsPDF();

        doc.setProperties({ title: "Calculadora Fiscal" });
        doc.addImage(image, 'PNG', 65, line, 90, 24);

        line = line + 40;
        doc.setLineHeightFactor(1.5);
        doc.setFontSize(12);

        let paragraph = "Elaboramos esta calculadora para que usted descubra el efecto máximo de la reforma fiscal \n" +
                    "en su bolsillo, según los montos que suele gastar al mes. Estos son sus resultados:";

        doc.text(paragraph, margin, line, null, null, 'left');

        line = line + breakLine + breakLine;

        doc.setFontSize(14);
        availableKeys.map( (cat, idx) => {
            var rowSIva = cat === 'renta' ? 'Impuesto antes' : 'Precio antes';
            var rowCIva = cat === 'renta' ? 'Impuesto ahora' : 'Precio ahora';

            let startY = doc.previousAutoTable.finalY ? doc.previousAutoTable.finalY + breakLine : line;
            doc.text(cart[cat].category, margin, startY);

            var head = [{prod: 'Producto o servicio', mount: 'Monto', rowSIva: rowSIva, rowCIva: rowCIva, diff: 'Diferencia'}];
            var body = [];

            var mount = 0;
            var mountBeforeIVA = 0;
            var mountAfterIVA = 0;
            var totalDiff = 0;

            //detalle de los productos
            var itemsKey = Object.keys( cart[cat].items );
            itemsKey.map( key => {
                var msi = cart[cat].items[key].prevValue ? cart[cat].items[key].prevValue : cart[cat].items[key].oldValue;
                body.push({prod: cart[cat].items[key].name, mount: cart[cat].items[key].oldValue, rowSIva: msi, rowCIva: cart[cat].items[key].newValue, diff: cart[cat].items[key].diff});

                mount = mount + parseInt( cart[cat].items[key].oldValue, 10);
                mountBeforeIVA = mountBeforeIVA + parseInt( (cart[cat].items[key].prevValue !== undefined ? cart[cat].items[key].prevValue : cart[cat].items[key].oldValue), 10 );
                mountAfterIVA = mountAfterIVA + parseInt( cart[cat].items[key].newValue, 10 );
                totalDiff = totalDiff + parseInt( cart[cat].items[key].diff, 10 );
            });

            var foot = [{prod: 'Total', mount: mount, rowSIva: mountBeforeIVA, rowCIva: mountAfterIVA, diff: totalDiff}];
            if( idx == catLenght - 1 ) {
                foot.push({prod: 'Total', mount: this.totals.mount, rowSIva: this.totals.mountBeforeIVA, rowCIva: this.totals.mountAfterIVA, diff: this.totals.totalDiff})
            }

            startY = doc.previousAutoTable.finalY ? doc.previousAutoTable.finalY + breakLine + 5 : line + 5;
            doc.autoTable({ 
                head: head,
                body: body,
                foot: foot,
                theme: 'plain',
                startY: startY,
                bodyStyles: {valign: 'top'},
                styles: {cellWidth: 'wrap', rowPageBreak: 'auto', halign: 'justify'},
                columnStyles: {prod: {cellWidth: 'auto'}}
            });
        })

        //doc.save('presupuesto.pdf');
        let blob = doc.output('blob', 'presupuesto');
        window.open(URL.createObjectURL(blob));
    }

    reset( ) {
        this.props.reset();
        this.props.close();
    }

    render() {
        const availableKeys = this.getAvailableKeys();
        const last = availableKeys.length; 
        this.initTotals();

        return <div id="invoice" className="modal-content">
            <div className="modal-header">
                <button type="button" className="close" onClick={this.props.close}>x</button>
                <h1>Mis Productos y Servicios</h1>
            </div>
            <div className="modal-body">
                <div className="content">
                    <div className="bd-example">
                        { this.props.count > 0 ? 
                            <React.Fragment>
                                { availableKeys.map( (key, idx) => this.getDetail(key, idx, (idx == last -1)) ) }
                            </React.Fragment>
                            :
                            <p style={{marginBottom: '20px'}}>No hay productos en el carrito</p> }
                    </div>
                </div>
            </div>
            { this.props.count > 0 && 
                <div className="modal-footer">
                    <strong><a onClick={() => this.generatePdf()} target="_blank">Descargar factura</a></strong>
                    <strong><a onClick={() => this.reset()} style={{marginBottom: '15px'}} target="_blank">VOLVER A CALCULAR</a></strong>
                    <button type="button" className="btn btn-default" onClick={this.props.close}>Cerrar</button>
                </div>
            }
        </div>
    }

}

export default Invoice;